import { render, staticRenderFns } from "./DiasSelectModal.vue?vue&type=template&id=40c5bdf2&scoped=true"
import script from "./DiasSelectModal.vue?vue&type=script&lang=js"
export * from "./DiasSelectModal.vue?vue&type=script&lang=js"
import style0 from "./DiasSelectModal.vue?vue&type=style&index=0&id=40c5bdf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c5bdf2",
  null
  
)

export default component.exports